module.exports = __webpack_public_path__ + "assets/img/mengban.87f0841a.png";